import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { createActionTypeModel } from "./action-model";

export const mapKeyToAction = (storeNs, actionKeys = ['']) => {
  return mapActions(storeNs, actionKeys.reduce((accm, cur) => {
    // console.log({
    //   ...accm,
    //   [cur]: cur
    // });
    return {
      ...accm,
      [cur]: cur
    };
  }, {}))
}
export const mapActionObject = (storeNs, actionsObject = []) => {
  return mapActions(storeNs, Object.keys(actionsObject));
}
export const mapAppActionObject = (actionsObject = []) => {
  return mapActions(Object.keys(actionsObject));
}
export const mapGetterObject = (storeNs, gettersObject = []) => {
  return mapGetters(storeNs, Object.keys(gettersObject));
}
export const mapAppGetterObject = (gettersObject = []) => {
  return mapGetters(Object.keys(gettersObject));
}


export const GlobalActionFlags = {
  noDatabaseUpdate: 'noDatabaseUpdate',
}